import { DossiersStateType } from './types';

export const CommandeSelector = (s: DossiersStateType) => s.dossiers.commande;

export const DossierSelector = (s: DossiersStateType) => s.dossiers.dos;

export const FactureVenteSelector = (s: DossiersStateType) => s.dossiers.facturevente;

export const JournalSelector = (s: DossiersStateType) => s.dossiers.jal;

export const RubriqueFacturationSelector = (s: DossiersStateType) => s.dossiers.rubfac;

export const TauxTvaSelector = (s: DossiersStateType) => s.dossiers.txtva;
